import React from 'react';
import { Table } from '../index.js';
import DocumentsTableRow from './DocumentsTableRow.js';
const DocumentsTable = (props) => {
    const documents = props.documents || [];
    return (React.createElement(Table, { zebra: true, style: { width: '100%' } }, documents
        .map((doc) => {
        return (React.createElement(DocumentsTableRow, { key: doc.documentId, document: doc, case: props.case, role: props.role, name: props.name, refId: props.refId, connectMappings: props.connectMappings }));
    })
        .sort((a, b) => a.props.document.id - b.props.document.id)));
};
export default DocumentsTable;
//# sourceMappingURL=DocumentsTable.js.map